import React from 'react';
import { useSelector } from 'react-redux';
import { selectAppSettings } from 'store/reducers/appSettings/appSettings.slice';
import { Box, Typography } from '@mui/material';

const BermudaInfo = () => {
  const { contact, contactHours } = useSelector(selectAppSettings);

  return (
    <Box>
      <Typography sx={styles.heading}>Accessing the site:</Typography>
      <Typography sx={styles.content}>
        For optimal viewing, we recommend using the latest version of Chrome,
        Edge or Safari.
      </Typography>
      <Typography sx={styles.content}>
        If you have any questions or require a new temporary password, please
        contact <strong>{contact}</strong> {contactHours}
      </Typography>
      <Typography sx={styles.heading}>Site stipulations:</Typography>
      <Typography sx={styles.content}>
        Your username will automatically be logged off when it has been inactive
        for 15 minutes. In addition, you will lose any unsaved data.
      </Typography>
      <Typography sx={styles.content}>
        Access and use of this website is for authorized users only.
      </Typography>
    </Box>
  );
};

const styles = {
  heading: {
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    color: '#000000',
    marginBottom: '16px',
    textAlign: 'left',
  },
  content: {
    fontWeight: '400',
    textAlign: 'left',
    marginBottom: '20px',
    marginTop: '20px',
  },
};

export default BermudaInfo;
